<script lang="ts">
import { Button, TextInput } from '@viamrobotics/prime-core';

export let value: string;
export let onInput: (event: Event) => void;
export let onSubmit: () => void;
</script>

<form
  on:submit|preventDefault={onSubmit}
  aria-label="Create organization"
  class="flex items-end gap-1 px-4 pb-1 pt-4"
>
  <TextInput
    aria-label="Organization name"
    {value}
    placeholder="New organization"
    on:input={onInput}
  />
  <Button
    variant="dark"
    type="submit"
  >
    Create
  </Button>
</form>
